import ThumbnailTracked from './ThumbnailTracked';
export default ThumbnailTracked;
